// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__u-9z5","row":"Footer_row__1VEsH","text":"Footer_text__3_Hud"};